// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import { menuPanelRowResetStyles, menuPanelRowStyles } from "@store/Themes/common/mixins/menu";
import { buttonResetProps } from "@store/Themes/common/props/button";
import { menuPanelProps } from "@store/Themes/common/props/menu";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import ChevronLeft from "@toolkit/Library/Components/Icons/ChevronLeft";
import ChevronRight from "@toolkit/Library/Components/Icons/ChevronRight";
import { css } from "styled-components";

const panelMenu: Styleguide["panelMenu"] = {
    defaultProps: {
        cssOverrides: {
            children: menuPanelProps.wrapperCss,
            menu: css`
                flex: 1 1 auto;
            `,
        },
        closeButtonPanelRowProps: {
            css: menuPanelProps.headerCss,
        },
        closeButtonProps: menuPanelProps.closeButton,
        closeIconProps: menuPanelProps.closeButtonIcon,
        parentPanelRowProps: {
            css: menuPanelRowResetStyles(),
        },
        parentButtonProps: {
            ...buttonResetProps,
            css: css`
                ${buttonResetProps.css}
                ${menuPanelRowStyles()}
                display: flex;
                align-items: center;
                width: 100%;
                text-align: left;
                font-weight: ${x => x.theme.design.typography.weight.base};
            `,
        },
        parentLinkProps: {
            css: css`
                ${menuPanelRowStyles({
                    iconPosition: "right",
                    color: "menu.mainNavigation.accent",
                    hoverColor: "menu.mainNavigation.accentHover",
                })}

                flex: 0 0 0%;
                white-space: nowrap;
                padding-left: 0;
            `,
        },
        backIconProps: { src: ChevronLeft },
        parentTypographyProps: { ellipsis: true },
        bodyColor: "transparent",
        panelRowProps: {
            css: menuPanelRowStyles({ iconPosition: "right" }),
            isCurrentCss: css`
                background-color: transparent;
                text-decoration: underline;
                color: ${getColor("menu.mainNavigation.hover")};
            `,
            moreIconProps: { src: ChevronRight },
        },
        childTypographyProps: {
            size: "inherit",
            weight: "inherit",
        },
    },
};

export default panelMenu;
